import { format } from '~/lib/date/dateTime'
import type { DateTime } from '../graphql/scalars'

export const formattedEndDateTime = (endDateTime?: DateTime) => {
  return endDateTime && format(endDateTime, 'yyyy年MM月dd日H:mm')
}
